import { render, staticRenderFns } from "./OrgTreeShow.vue?vue&type=template&id=63173ca6"
import script from "./OrgTreeShow.vue?vue&type=script&lang=js"
export * from "./OrgTreeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports